import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/duty";
import { list as doctorList } from "../requests/doctor";
import { list as roomList } from "../requests/room";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function useDutyForm(props) {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [doctors, setDoctors] = createSignal([]);
  const [rooms, setRooms] = createSignal([]);
  const [days, setDays] = createSignal([
    { text: "Monday", value: "Monday" },
    { text: "Tuesday", value: "Tuesday" },
    { text: "Wednesday", value: "Wednesday" },
    { text: "Thursday", value: "Thursday" },
    { text: "Friday", value: "Friday" },
    { text: "Saturday", value: "Saturday" },
    { text: "Sunday", value: "Sunday" }
  ]);
  const [times, setTimes] = createSignal([]);
  const [key, setKey] = createSignal(null);
  const [form, setForm] = createStore({
    day: "",
    doctorId: null,
    roomId: null,
    startTime: 0,
    endTime: 0,
  });

  const clearForm = () => {
    setForm('day', "");
    setForm('doctorId', null);
    setForm('roomId', null);
    setForm('startTime', 0);
    setForm('endTime', 0);
  }

  const fetchInfo = async (pid) => {
    setFetching(true);
    setKey(pid);
    try {
      console.log(key());
      const response = await get(key());
      const data = response.entity;
      setForm('day', data.day);
      setForm('roomId', data.roomId);
      setForm('doctorId', data.doctorId);
      setForm('startTime', data.startTime);
      setForm('endTime', data.endTime);
    } catch (error) {
      throw error;
    }  finally {
      setFetching(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };

  const handleSave = async (ev) => {
    ev?.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        formData.append(key, form[key])
      });
      if (key() !== null) {
        formData.append('id', key());
      }

      if (formData.doctorId === null) {
        errorToast('Please select a doctor');
        return;
      }

      if (formData.roomId === null) {
        errorToast('Please select a room');
        return;
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        props?.onClose();
        props?.onRefresh();
        return;
      }

      errorToast(data.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  onMount(async () => {
    try {
      const data = await doctorList();
      setDoctors(data.list);
    } catch(error) {
      setDoctors([]);
    }

    try {
      const data = await roomList();
      setRooms(data.list);
    } catch(error) {
      setRooms([]);
    }

    let times = [];
    for (let i = 0; i < 24; i++) {
      times.push({ text: `${i}:00`, value: i * 100 });
      times.push({ text: `${i}:15`, value: i * 100 + 15 });
      times.push({ text: `${i}:30`, value: i * 100 + 30 });
      times.push({ text: `${i}:45`, value: i * 100 + 45 });
    }

    times.push({ text: `24:00`, value: 2400 });
    setTimes(times);
  })

  return {
    loading,
    clearForm,
    fetching,
    form,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange,
    doctors,
    rooms,
    days,
    times,
  };
}
